module.exports = __webpack_public_path__ + "img/idCard.f899decf.jpg";